import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';

interface AdminAccessDeniedProps {
  message?: string;
}

export const AdminAccessDenied: React.FC<AdminAccessDeniedProps> = ({ 
  message = "Vous n'avez pas les permissions nécessaires pour accéder à cette page." 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001122] to-[#000811] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card principale */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
          {/* Icône */}
          <div className="mx-auto w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mb-6">
            <ShieldX className="w-10 h-10 text-red-400" />
          </div>

          {/* Titre */}
          <h1 className="text-2xl font-bold text-white mb-2">
            Accès Refusé
          </h1>

          {/* Message */}
          <p className="text-gray-400 mb-8">
            {message}
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour
            </button>
            
            <Link
              to="/admin/dashboard"
              className="inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#B8941F] text-[#001122] font-medium rounded-lg hover:opacity-90 transition-opacity"
            >
              <Home className="w-4 h-4 mr-2" />
              Tableau de bord
            </Link>
          </div>
        </div>

        {/* Note */}
        <p className="text-center text-gray-500 text-sm mt-6">
          Si vous pensez qu'il s'agit d'une erreur, contactez votre administrateur.
        </p>
      </div>
    </div>
  );
};

export default AdminAccessDenied;
